module.exports = __webpack_public_path__ + "img/web_1_2x.9cde65ef.webp";